import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { GeoAreaRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/geo-area-request';
import { Field } from 'src/app/tools/models/dtos/field';
import { GeoAreaType } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-type-entity';
import { GeoAreaLovComponent } from '../geo-area-lov/geo-area-lov.component';


@Component({
  selector: 'geoarea-list',
  templateUrl: './geoarea-list.component.html',
  styleUrls: ['./geoarea-list.component.scss']
})

export class GeoAreaListComponent extends BasePage2<GeoArea> {


  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  geoAreas      : GeoArea[] = [];
  geoAreaTypes  : GeoAreaType[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName =  "geoArea";
      
  }

//----------------------------------------------------------------------
ngAfterViewInit(){

  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlTablesService.getList('geoAreaType', request).then(result => {
      this.geoAreaTypes = result;

      super.ngAfterViewInit();
  })

}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
getRows(): GeoArea[] {
    return this.geoAreas;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(row: GeoArea): Promise<GeoArea> {
    let request: GeoAreaRequest = new GeoAreaRequest(this.controlTablesService.getUserInfo());
    request.geoArea = row;
    return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
new(){
    let entity : GeoArea = new GeoArea();
    entity.inserted = true;
    entity.edit = true;
    this.geoAreas.push(entity);
    this.geoAreas = [...this.geoAreas];
  }
//----------------------------------------------------------------------

        
//----------------------------------------------------------------------
loadData() {
  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = this.code;
  request.strArg2 = this.name;

  this.controlTablesService.getList(this.entityName, request).then(result => {
      this.geoAreas = result;
  })
}
// ---------------------------------------------------------------------


//----------------------------------------------------------------------
enrichField(field : Field){
  
  if (field.prop == 'geoAreaType') {
      field.lov =   {key : "geoAreaTypeCode",  value : "name",  data : this.geoAreaTypes } ;
      field.key = 'geoAreaTypeCode';
      return;
  }

  if (field.prop == 'upGeoArea') {
    field.modal   =  GeoAreaLovComponent ;
    field.subProp = 'name';
    return;
  }
}
//----------------------------------------------------------------------


}